module.exports = __webpack_public_path__ + "images/commercial.bc8f0f65f3cb6840535325990aecd789.svg";